import { render, staticRenderFns } from "./BerkleyActions.vue?vue&type=template&id=2f571a8d"
import script from "./BerkleyActions.vue?vue&type=script&lang=js"
export * from "./BerkleyActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports